export const PORTAL_LOGO_SRC = '/portal-logo.svg';

const loadImage = async (src: string) => {
  return await new Promise<HTMLImageElement | null>((resolve) => {
    const image = new window.Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => resolve(null);
    image.src = src;
  });
};

const loadCanvas = (width: number, height: number) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  return canvas;
};

export const loadPortalLogoImage = async () => {
  try {
    const response = await fetch(PORTAL_LOGO_SRC);
    if (!response.ok) {
      return null;
    }

    const svgText = await response.text();
    const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgText)}`;
    const image = await loadImage(svgDataUrl);

    if (!image) {
      return null;
    }

    const canvas = loadCanvas(image.naturalWidth, image.naturalHeight);
    const context = canvas.getContext('2d');

    if (!context) {
      return null;
    }

    context.drawImage(image, 0, 0);
    return {
      dataUrl: canvas.toDataURL('image/png'),
      height: image.naturalHeight,
      width: image.naturalWidth,
    };
  } catch {
    return null;
  }
};
